<template>
  <div class="Realisation w-100">
    <div
      v-if="getIsSavingProcess"
      class="spinner-full-window d-flex"
    >
      <b-spinner
        variant="primary"
        class="spinner"
      />
    </div>
    <div v-else>
      <div class="d-flex justify-content-center flex-gap-2">
        <div class="process-main">
          <RealisationHeader
            :record="record"
            :feedback="feedback"
            :feedback-message="feedbackMessage"
            :step="step"
            :record-step="currentStep"
            :may-edit="mayEdit && isCompletedStep"
            @dismissed="(feedback = null, feedbackMessage = '')"
          >
            <FlowInteraction
              :first="currentStep === 1"
              :last="isFinalStep"
              :step="step"
              :current-step="currentStep"
              :locked="locked"
              :disabled="disabled"
              :completed="completed"
              :is-completed-step="isCompletedStep"
              :show-next-button="false"
              :disable-next-btn="disableNextBtn"
              :disable-save-btn="!isCategoryValid"
              :may-edit="mayEdit"
              :open-for-change="openForChange"
              :location-connected="isLocationConnected"
              :record="record"
              @handleNext="handleNext"
              @handlePrevious="handlePrevious"
              @handleSubmitAndNext="handleSubmitAndNext"
              @handleCancelChange="handleCancelChange"
              @handleStartCorrection="handleStartCorrection"
              @handleStartChange="handleStartChange"
              @handleComplete="handleComplete"
              @handleSubmit="saveRecord"
            />
          </RealisationHeader>
          <router-view
            :key="$route.path"
            ref="form"
            class="process-form"
            :connection-enabled="isLocationConnected"
            :can-change-location="true"
            @isLocationConnected="event => (isLocationConnected = event, locked = false)"
            @isCategoryValid="event => isCategoryValid = event"
            @currentRecord="record => (currentRecord = record, correction = false)"
            @feedback="event => (feedback = event.feedback, feedbackMessage = event.message)"
            @handleInput="handleInput"
            @handleCancelChange="event => locked = event"
            @isSaving="event => isSaving = event"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import RealisationHeader from '@/components/realisation/RealisationHeaderNewProcess.vue';
import FlowInteraction from '@/components/flow/FlowInteraction.vue';

import CustomBaseStep from '@/views/processes/CustomBaseStep.vue';

export default {
  name: 'StartNewCustomProcess',
  components: {
    RealisationHeader,
    FlowInteraction
  },
  mixins: [CustomBaseStep],
  data() {
    return {
      isLocationConnected: false,
      loadingStatus: {
        pagedWorkflows: {
          error: 0,
          target: 0,
          current: 0
        }
      },
      failed: false,
      missingWorkflows: [],
      defaultFilter: 'actief',
      realisationsListKey: 0,
      realisationUuid: null,
      category: '',
      isForbidden: false,
      currentRecord: null,
      notFound: false,
      token: '',
      sidebarKey: 0,
      isSaving: false,
      isCategoryValid: true
    };
  },

  computed: {
    ...mapGetters('realisations', ['getSelectedRecord']),
    ...mapGetters('user', ['canAccessRequests', 'canAccessRealisationProcesses', 'roleDetailsMerged']),
    ...mapGetters('tenant', ['isCurrentTenant', 'getSteps']),
    ...mapGetters('processes', ['getSelectedProcess', 'getCurrentProcessType', 'getIsSavingProcess']),
    ...mapGetters('chargingpoints', ['getActiveMunicipality']),
    userIdentity () {
      const identity = this.$auth.user['https://evtools.nl/identity']
      return identity?.uuid //&& identity.category === 'cpo'
        ? this.$auth.user['https://evtools.nl/identity']
        : {}
    },
    lastStep () {
      return this.getSteps?.at(-1)?.step
    },
    isFinalStep () {
      return this.currentStep === this.lastStep
    },
    disableNextBtn () {
      return !this.isCategoryValid
    }
  },

  watch: {
    $route: {
      deep: true,
      async handler () {
        this.feedback = null;
        this.feedbackMessage = ''
      }
    }
  },

  async created () {
    this.$store.dispatch('realisations/setSelectedRecord', { record: null })
    this.$store.dispatch('processes/setSelectedProcess', { process: null })
    this.$store.dispatch('chargingpoints/setActiveMunicipality', { code: '' })
    this.$store.dispatch('chargingpoints/resetRecords')
    this.$store.dispatch('processes/isSavingProcess', false)

    this.categories = this.getProcessCategories
  },
  methods: {
    ...mapActions('requests', ['loadConnectedRequests']),
  }
};
</script>
